/* eslint-disable wrap-iife */
/* eslint-disable prefer-rest-params */
/* eslint-disable no-extra-semi */
/* eslint-disable func-names */
/* eslint-disable no-underscore-dangle */
/* eslint-disable prefer-destructuring */
import React from 'react'
// { useEffect }
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import { v4 as uuid } from 'uuid'
// import { parseJwt } from 'common/utils/jwt'

// Route Configurations
import Routes from 'common/config/route'

// Global Components
import GlobalComponents from 'views/global'

function Routing() {
  /**
   * Conditionally selects route/component to render based on authentication or authorization
   * @param  {} isRouteProtected
   * @param  {} routeRoleAccess
   * @param  {} component
   */
  const renderRouteComponent = ({ component }) => (
    <>
      {React.createElement(component)}
      <GlobalComponents />
    </>
  )

  return (
    <BrowserRouter>
      <Switch>
        {Routes.map(
          ({ isRoutePublic, isRouteProtected, isRouteAdmin, exact, roleAccess, routing: { path, component } }) => (
            <Route
              exact={exact}
              path={path}
              key={uuid()}
              render={() =>
                renderRouteComponent({ isRoutePublic, isRouteProtected, isRouteAdmin, roleAccess, component, path })
              }
            />
          )
        )}
      </Switch>
    </BrowserRouter>
  )
}
export default Routing
